import React from 'react';
import { TrendingUp, BarChart3, ArrowLeft, Clock } from 'lucide-react';

const leadTimeTypeOptions = [
  { 
    key: 'analysis', 
    label: 'Scatterplot & Histograma', 
    description: 'Análise de dispersão e distribuição dos tempos de ciclo',
    icon: TrendingUp,
    color: 'from-blue-500 to-indigo-500',
    bgColor: 'from-blue-50 to-indigo-50'
  },
  { 
    key: 'breakdown', 
    label: 'Lead Time Breakdown', 
    description: 'Análise detalhada das etapas do fluxo de trabalho',
    icon: BarChart3,
    color: 'from-purple-500 to-pink-500',
    bgColor: 'from-purple-50 to-pink-50'
  },
];

function LeadTimeTypeSelector({ selected, onSelect, onBack }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-8">
        {/* Title Section */}
        <div className="text-center mb-6">
          {/* Back Button - Alinhado ao título */}
          <div className="flex justify-center mb-4">
            <button
              className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-700 hover:text-blue-600 hover:border-blue-300 font-medium transition-all duration-200 shadow-sm hover:shadow-md"
              onClick={onBack}
              type="button"
            >
              <ArrowLeft className="w-4 h-4" />
              Voltar
            </button>
          </div>
          
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-100 rounded-full mb-4">
            <Clock className="w-4 h-4 text-blue-600" />
            <span className="text-blue-800 font-medium text-sm">Lead Time</span>
          </div>
          
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
            Escolha o tipo de análise
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Selecione a visualização mais adequada para suas necessidades de análise
          </p>
        </div>
        
        {/* Options Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
          {leadTimeTypeOptions.map(option => {
            const Icon = option.icon;
            const isSelected = selected === option.key;
            
            return (
              <button
                key={option.key}
                onClick={() => onSelect(option.key)}
                className={`group relative bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border text-left ${
                  isSelected 
                    ? 'border-blue-500 ring-2 ring-blue-200' 
                    : 'border-gray-200 hover:border-blue-300'
                }`}
              >
                {/* Selection Indicator */}
                {isSelected && (
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                    <div className="w-2 h-2 bg-white rounded-full"></div>
                  </div>
                )}
                
                {/* Icon */}
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-r ${option.bgColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <div className={`w-10 h-10 rounded-xl bg-gradient-to-r ${option.color} flex items-center justify-center`}>
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                </div>
                
                {/* Content */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                    {option.label}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {option.description}
                  </p>
                </div>
                
                {/* Hover Arrow */}
                <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                    <ArrowLeft className="w-4 h-4 text-white transform rotate-180" />
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default LeadTimeTypeSelector;
